import {
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_FILL_IN_BLANKS_RESPONSE,
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_MULTIPLE_CHOICE,
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_RESPONSE,
  ACTIVITIES_COMPONENT_TYPE_DISCUSSION_RESPONSE,
  ACTIVITIES_COMPONENT_TYPE_DRAW,
  ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE,
  ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE_CATEGORISE,
  ACTIVITIES_COMPONENT_TYPE_TABLE,
  ActivitiesContentType,
} from 'global/constants';
import {
  ComponentDiscussion,
  ComponentDraw,
  ComponentFillInBlanks,
  ComponentInteractiveResponseCategorise,
  ComponentInteractiveResponseSequence,
  ComponentMultipleChoice,
  ComponentResponse,
  ComponentTable,
} from '../../component.constants';
import { Box } from 'approot/shared/design-system/box/box.style';
import { useGetResponseComponents } from './suggested-answer-view.hooks';
import AccordionToggleNew from 'approot/shared/accordion/accordion-toggle-new';
import SuggestedAnswerTextResponseView from './suggested-answer-text-response-view';
import SuggestedAnswerTableView from './suggested-answer-table-view';
import SuggestedAnswerMultipleChoiceView from './suggested-answer-multiple-choice-view';
import SuggestedAnswerCategoriseView from './suggested-answer-categorise-view';
import SuggestedAnswerDrawView from './suggested-answer-draw-view';
import SuggestedAnswerDiscussionView from './suggested-answer-discussion-view';
import SuggestedAnswerSequenceView from './suggested-answer-sequence-view';
import SuggestedAnswerFillInBlanksView from './fill-in-blanks/suggested-answer-fill-in-blanks-view';

type Props = {
  contentType: ActivitiesContentType;
  contentId: number;
  currentSectionId: string;
  urlSectionId?: string;
  version?: string | null;
  isPublic?: boolean;
  classId: number | null;
};

const SuggestedAnswersView = ({
  contentType,
  contentId,
  currentSectionId,
  urlSectionId,
  version,
  isPublic,
  classId,
}: Props) => {
  const { responseComponents, hasAnswers, isUnitQuiz } =
    useGetResponseComponents({
      contentId,
      contentType,
      currentSectionId,
      urlSectionId,
      version,
      isPublic,
      classId,
    });

  return isUnitQuiz || hasAnswers ? (
    <AccordionToggleNew title="Answers" withDividers>
      {responseComponents.map(component => (
        <Box $marginBottom={24} key={component.id}>
          {component.type ===
            ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_RESPONSE && (
            <SuggestedAnswerTextResponseView
              component={component as ComponentResponse}
              isUnitQuiz={isUnitQuiz}
            />
          )}
          {component.type === ACTIVITIES_COMPONENT_TYPE_DISCUSSION_RESPONSE && (
            <SuggestedAnswerDiscussionView
              component={component as ComponentDiscussion}
              isUnitQuiz={isUnitQuiz}
            />
          )}
          {component.type === ACTIVITIES_COMPONENT_TYPE_TABLE && (
            <SuggestedAnswerTableView
              component={component as ComponentTable}
              isUnitQuiz={isUnitQuiz}
            />
          )}
          {component.type ===
            ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_MULTIPLE_CHOICE && (
            <SuggestedAnswerMultipleChoiceView
              component={component as ComponentMultipleChoice}
              isUnitQuiz={isUnitQuiz}
            />
          )}
          {component.type ===
            ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE && (
            <SuggestedAnswerSequenceView
              component={component as ComponentInteractiveResponseSequence}
              isUnitQuiz={isUnitQuiz}
            />
          )}

          {component.type ===
            ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE_CATEGORISE && (
            <SuggestedAnswerCategoriseView
              component={component as ComponentInteractiveResponseCategorise}
              isUnitQuiz={isUnitQuiz}
            />
          )}
          {component.type === ACTIVITIES_COMPONENT_TYPE_DRAW && (
            <SuggestedAnswerDrawView
              component={component as ComponentDraw}
              isUnitQuiz={isUnitQuiz}
            />
          )}

          {component.type ===
            ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_FILL_IN_BLANKS_RESPONSE && (
            <SuggestedAnswerFillInBlanksView
              component={component as ComponentFillInBlanks}
              isUnitQuiz={isUnitQuiz}
            />
          )}
        </Box>
      ))}
    </AccordionToggleNew>
  ) : null;
};

export default SuggestedAnswersView;
